import { render, staticRenderFns } from "./ExpertConsultant.vue?vue&type=template&id=5f380ea6&scoped=true&"
import script from "./ExpertConsultant.vue?vue&type=script&lang=js&"
export * from "./ExpertConsultant.vue?vue&type=script&lang=js&"
import style0 from "./ExpertConsultant.vue?vue&type=style&index=0&id=5f380ea6&prod&scoped=true&lang=css&"
import style1 from "./ExpertConsultant.vue?vue&type=style&index=1&id=5f380ea6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f380ea6",
  null
  
)

export default component.exports